<p [ngClass]="[typography(), typographyMobile() ? 'mobile-' + typographyMobile() : '', hideOverflowEllipsis() ? 'hide-overflow-ellipsis' : '']"><ng-content></ng-content></p>
